export const isCompareYtdTotalsEntry = (value) =>
  Boolean(value && typeof value === "object" && ("compare" in value || "actual" in value));

export const hasCompareYtdTotalsForTable = (totalsByRows, tableKey) =>
  Object.values(totalsByRows?.[tableKey] || {}).some(isCompareYtdTotalsEntry);

export const getCompareYtdFieldValue = (entry, field) => {
  if (!isCompareYtdTotalsEntry(entry)) return null;
  if (field === "variance") {
    if (entry?.variance !== null && entry?.variance !== undefined) return entry.variance;
    const hasActual = entry?.actual !== null && entry?.actual !== undefined;
    const hasCompare = entry?.compare !== null && entry?.compare !== undefined;
    if (!hasActual && !hasCompare) return null;
    return Number(entry?.actual || 0) - Number(entry?.compare || 0);
  }
  return entry?.[field] ?? null;
};

export const getCompareYtdColumnConfig = (compareType) => {
  if (String(compareType || "").startsWith("budget-")) {
    return [
      { label: "YTD Actual", field: "actual" },
      { label: "YTD Forecast", field: "compare" },
      { label: "YTD Variance", field: "variance", isVariance: true },
    ];
  }
  return [
    { label: "YTD Previous", field: "compare" },
    { label: "YTD Actual", field: "actual" },
    { label: "YTD Variance", field: "variance", isVariance: true },
  ];
};

export const isPercentageMetricName = (metric) =>
  metric === "BEROAS" ||
  metric === "EBITDA Margin" ||
  metric === "Net margin" ||
  metric === "MER" ||
  metric.includes("%") ||
  metric.includes("Ratio");
